var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-center",domProps:{"textContent":_vm._s(_vm.$t('view.users.allUsers'))}}),_c('accounts-table',{attrs:{"accounts":_vm.accounts,"showAccount":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }